import * as api from "../api/index";
import history from "../";

import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  SIGNUP_USER_REQUEST,
  SIGNUP_USER_SUCCESS,
  SIGNUP_USER_FAIL,
  LOAD_USER_REQUEST,
  LOAD_USER_SUCCESS,
  LOAD_USER_FAIL,
  CLEAR_ERRORS,
  LOGIN_WITH_OTP_SUCCESS,
} from "../constants/userConstant";

// Login
export const login = (data, history, setLoad) => async (dispatch) => {
  const { email, password } = data;
  try {
    setLoad(true);
    dispatch({ type: LOGIN_REQUEST });

    const { data } = await api.postLogin(email, password);
    console.log({ data, email: data?.patient?.email }, "email of payload");
    dispatch({
      type: LOGIN_SUCCESS,
      payload: data?.patient?.email,
    });
    setLoad(false);

    // localStorage.setItem("auth", true);

    history.push(`/otp-verification`);
    // }
  } catch (error) {
    setLoad(false);
    dispatch({
      type: LOGIN_FAIL,
      payload: error?.response?.data?.message,
    });
  }
};

// validateOtp
export const validateOtp = (data, setLoad) => async (dispatch) => {
  const { code, email } = data;
  try {
    setLoad(true);
    dispatch({ type: LOGIN_REQUEST });

    const { data } = await api.validateOtp(email, code);

    dispatch({
      type: LOGIN_WITH_OTP_SUCCESS,
      payload: data,
    });
    setLoad(false);

    localStorage.setItem("auth", true);

    window.location.pathname = "/";
  } catch (error) {
    setLoad(false);
    dispatch({
      type: LOGIN_FAIL,
      payload: error?.response?.data?.message,
    });
  }
};

//
// Register User
export const signUp = (userData) => async (dispatch) => {
  try {
    dispatch({ type: SIGNUP_USER_REQUEST });

    const { data } = await api.postSignUp(userData);
    console.log(data);

    dispatch({
      type: SIGNUP_USER_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    console.log(error);
    dispatch({
      type: SIGNUP_USER_FAIL,
      payload: error?.response?.data?.message,
    });
  }
};

// Load user
export const loadUser = () => async (dispatch) => {
  try {
    dispatch({ type: LOAD_USER_REQUEST });

    const { data } = await api.getLoadUser();
    dispatch({
      type: LOAD_USER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.log(error.response);
    localStorage.removeItem("auth");
    localStorage.removeItem("token");
    localStorage.removeItem("isAuthenticated");
    dispatch({
      type: LOAD_USER_FAIL,
      payload: error?.response?.data?.message,
    });
  }
};

// Clear Errors
export const clearErrors = () => async (dispatch) => {
  dispatch({
    type: CLEAR_ERRORS,
  });
};

//
// // Update User Profile
// export const updateProfile = (userData) => async (dispatch) => {
//   try {
//     dispatch({ type: UPDATE_PROFILE_REQUEST });
//
//     const { data } = await api.putProfileUpdate(userData);
//
//     dispatch({
//       type: UPDATE_PROFILE_SUCCESS,
//       payload: data.success,
//     });
//   } catch (error) {
//     dispatch({
//       type: UPDATE_PROFILE_FAIL,
//       payload: error.response.data.errMessage,
//     });
//   }
// };
//
// // Update User Password
// export const updatePassword = (passwords) => async (dispatch) => {
//   try {
//     dispatch({ type: UPDATE_PASSWORD_REQUEST });
//
//     const { data } = await api.putUpdatePassword(passwords);
//
//     dispatch({
//       type: UPDATE_PASSWORD_SUCCESS,
//       payload: data.success,
//     });
//   } catch (error) {
//     dispatch({
//       type: UPDATE_PASSWORD_FAIL,
//       payload: error.response.data.errMessage,
//     });
//   }
// };
//
// // Forgot Password
// export const forgotPassword = (email) => async (dispatch) => {
//   try {
//     dispatch({ type: FORGOT_PASSWORD_REQUEST });
//
//     const { data } = await api.postForgotPassword(email);
//
//     dispatch({
//       type: FORGOT_PASSWORD_SUCCESS,
//       payload: data.message,
//     });
//   } catch (error) {
//     dispatch({
//       type: FORGOT_PASSWORD_FAIL,
//       payload: error.response.data.errMessage,
//     });
//   }
// };
//
// // New Password
// export const resetPassword = (token, passwords) => async (dispatch) => {
//   try {
//     dispatch({ type: NEW_PASSWORD_REQUEST });
//
//     const { data } = await api.postForgotPassword(token, passwords);
//
//     dispatch({
//       type: NEW_PASSWORD_SUCCESS,
//       payload: data.success,
//     });
//   } catch (error) {
//     dispatch({
//       type: NEW_PASSWORD_FAIL,
//       payload: error.response.data.errMessage,
//     });
//   }
// };
//
// // All User (Admin)
// export const allUsers = () => async (dispatch) => {
//   try {
//     dispatch({ type: ALL_USERS_REQUEST });
//
//     const { data } = await api.getAllUsers();
//
//     dispatch({
//       type: ALL_USERS_SUCCESS,
//       payload: data.users,
//     });
//   } catch (error) {
//     dispatch({
//       type: ALL_USERS_FAIL,
//       payload: error.response.data.errMessage,
//     });
//   }
// };
//
// // Update User (Admin)
// export const updateUser = (id, userData) => async (dispatch) => {
//   try {
//     dispatch({ type: UPDATE_USER_REQUEST });
//
//     const { data } = await api.putUpdateUser(id, userData);
//
//     dispatch({
//       type: UPDATE_USER_SUCCESS,
//       payload: data.success,
//     });
//   } catch (error) {
//     dispatch({
//       type: UPDATE_USER_FAIL,
//       payload: error.response.data.errMessage,
//     });
//   }
// };
//
// // Get User Details (Admin)
// export const getUserDetails = (id) => async (dispatch) => {
//   try {
//     dispatch({ type: USER_DETAILS_REQUEST });
//
//     const { data } = await api.getUserDetails(id);
//
//     dispatch({
//       type: USER_DETAILS_SUCCESS,
//       payload: data.user,
//     });
//   } catch (error) {
//     dispatch({
//       type: USER_DETAILS_FAIL,
//       payload: error.response.data.errMessage,
//     });
//   }
// };
//
// // Delete User (Admin)
// export const deleteUser = (id) => async (dispatch) => {
//   try {
//     dispatch({ type: DELETE_USER_REQUEST });
//
//     const { data } = await api.deleteUser(id);
//
//     dispatch({
//       type: DELETE_USER_SUCCESS,
//       payload: data.success,
//     });
//   } catch (error) {
//     dispatch({
//       type: DELETE_USER_FAIL,
//       payload: error.response.data.errMessage,
//     });
//   }
// };
//
// // Clear Errors
// export const clearErrors = () => async (dispatch) => {
//   dispatch({
//     type: CLEAR_ERRORS,
//   });
// };
